export enum ToastLife {
  DEFAULT = 3000,
  SHORT = 1500,
  MEDIUM = 5000,
  LONG = 10000,
}
